import styled from 'styled-components';

export const Video = styled.div``;
